/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The submissions a rejudge of the problem covers (#255): the confirmation names them and
 * the queued rejudge answers with them.
 * @export
 * @interface ProblemRejudgeSummary
 */
export interface ProblemRejudgeSummary {
    /**
     * 
     * @type {string}
     * @memberof ProblemRejudgeSummary
     */
    problem_id: string;
    /**
     * Submissions without a team: practice and workshops, and event submissions whose team was deleted
     * @type {number}
     * @memberof ProblemRejudgeSummary
     */
    practice_submissions: number;
    /**
     * Submissions of a team in an event
     * @type {number}
     * @memberof ProblemRejudgeSummary
     */
    event_submissions: number;
    /**
     * Every submission of the problem
     * @type {number}
     * @memberof ProblemRejudgeSummary
     */
    total_submissions: number;
}

/**
 * Check if a given object implements the ProblemRejudgeSummary interface.
 */
export function instanceOfProblemRejudgeSummary(value: object): value is ProblemRejudgeSummary {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('practice_submissions' in value) || value['practice_submissions'] === undefined) return false;
    if (!('event_submissions' in value) || value['event_submissions'] === undefined) return false;
    if (!('total_submissions' in value) || value['total_submissions'] === undefined) return false;
    return true;
}

export function ProblemRejudgeSummaryFromJSON(json: any): ProblemRejudgeSummary {
    return ProblemRejudgeSummaryFromJSONTyped(json, false);
}

export function ProblemRejudgeSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProblemRejudgeSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'practice_submissions': json['practice_submissions'],
        'event_submissions': json['event_submissions'],
        'total_submissions': json['total_submissions'],
    };
}

export function ProblemRejudgeSummaryToJSON(json: any): ProblemRejudgeSummary {
    return ProblemRejudgeSummaryToJSONTyped(json, false);
}

export function ProblemRejudgeSummaryToJSONTyped(value?: ProblemRejudgeSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'practice_submissions': value['practice_submissions'],
        'event_submissions': value['event_submissions'],
        'total_submissions': value['total_submissions'],
    };
}

